import { query,mutate,destroy, update } from "../../defaults/fetch";
import {useEffect,useState} from "react";


export const useCreateVoucherApproval = ()=>{
    const createVoucherApproval = async (body)=>{
        const url = `pvapprovalstage/create`;
        const response = await mutate(url,true,body);
        return response.message;
    }

    return createVoucherApproval;
}


export const useFetchVoucherApprovalStages = (flag)=>{
    const [voucherApprovals,setVoucherApprovals] = useState([]);
    const [loading,setLoading] = useState(false);


    useEffect(()=>{
        const getAllVoucherApprovals = async ()=>{
            setLoading(true);
            const url = `pvapprovalstage/get-all`
            const qs = {
                page:0,
                size:50
            };
            const {data} = await query(url,qs);
            setLoading(false);
            setVoucherApprovals(data)
        }
        getAllVoucherApprovals();
    },[flag]);

    return {loading,voucherApprovals};
}


export const useUpdateVocherApprovalStage = ()=>{
    const updateVocherApprovalStage = async (id,body)=>{
        const url = `pvapprovalstage/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateVocherApprovalStage;
}

export const useDeleteVoucherApprovalStage = ()=>{
    const deleteVoucherApprovalStage = async (id) =>{
        const url =`pvapprovalstage/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteVoucherApprovalStage;
}
